var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeatport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.7881L7.32832 11.4598L7.81581 10.9889C8.98471 9.82004 9.58524 8.39185 9.58524 6.70331V2H11.5852V7.50329C11.5852 9.19184 10.9847 10.62 9.81581 11.7889L9.68563 11.9191C10.7083 10.9773 12.1043 10.4095 13.5979 10.4095C16.8935 10.409 19.4097 13.0227 19.4097 16.1881C19.4097 19.4024 16.8448 22 13.5979 22C10.3837 22 7.8187 19.4677 7.8187 16.1881C7.8187 14.6464 8.40315 13.2825 9.32832 12.2598L5.39999 16.1881L4 14.7881ZM17.6386 16.3C17.6386 18.5091 15.8477 20.3 13.6386 20.3C11.4295 20.3 9.6386 18.5091 9.6386 16.3C9.6386 14.0908 11.4295 12.3 13.6386 12.3C15.8477 12.3 17.6386 14.0908 17.6386 16.3Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatport);
export default __webpack_public_path__ + "static/media/beatport.85b9ede166066d2c40e5540f0cf89aed.svg";
export { ForwardRef as ReactComponent };